module.exports = __webpack_public_path__ + "img/content5-1.e350d065.png";